import { useLocation } from "react-router-dom";
import { useNotificationPermissionStore } from "@/lib/push-notifications/store/notification-permission-store";
import { useAuthStore } from "@/lib/store/auth-enhanced";

/**
 * Simple hook that determines if the permission dialog should be shown
 *
 * Shows dialog when:
 * - User is authenticated
 * - Not on login page
 * - Permission can be requested (status is "prompt")
 * - User hasn't permanently dismissed it
 * - User hasn't temporarily dismissed it (24-hour cooldown)
 */
export function useShouldShowPermissionDialog() {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();
  const { isSupported, permission, isLoading } = useNotificationPermissionStore();

  const isOnLoginPage = location.pathname === "/login" || location.pathname === "/";

  // Check if user permanently dismissed
  const isPermanentlyDismissed =
    localStorage.getItem("notification-permission-permanently-dismissed") === "true";

  const shouldShow =
    !isLoading &&
    isAuthenticated &&
    !isOnLoginPage &&
    isSupported &&
    permission === "prompt" &&
    !isPermanentlyDismissed;

  return shouldShow;
}
